import React from 'react';
import classes from './Content.module.css';

const Content = (props) => {
    return (
        <div className={classes.cover}>
            <div className={classes.content}>
                {props.children}
            </div>
            <p className={classes.footerText}>A Fan recreation of <a href="http://mydrugs.to" target="_blank" rel="noreferrer">MyDrugs.to</a> (Netflix Series). Does not actually sell neither legal or illegal substances. <br/> Made by elMidori | <a href="#" target="_blank">Portfolio</a>  &copy; Copyright 2021.</p>
    
        </div>
    )
}

export default Content
